import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useGetCodeTimer() {
  const [timer, setTimer] = useState<number>(0);

  const getTimer = useCallback(
    async (data: typeof RegionShared.Backend.Requests.GetThrottleStateRequest) => {
      try {
        const response = await AccountMpProvider.getCodeTimer(data);

        if (response instanceof RpcMpProviderSuccessResponse) {
          setTimer(response.data.seconds);
        } else {
          setTimer(0);
        }
      } catch (e) {
        setTimer(0);
      }
    },
    [],
  );

  return { timer, getTimer };
}
